import { useState } from "react";
import OrderDetails from "../components/orders/OrderDetails";
import OrderSummaryCard from "../components/orders/OrderSummaryCard";
import { useFetchPastOrdersQuery } from "../store";
import Pagination from "../components/common/Pagination";

const OrderHistory = () => {
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(20);
  const [selectedOrderId, setSelectedOrderId] = useState<string | undefined>();
  const { data } = useFetchPastOrdersQuery({ page, perPage });

  const renderedPastOrders = data?.orders.map((order) => {
    return (
      <OrderSummaryCard
        key={`new-${order._id}`}
        order={order}
        selectOrder={setSelectedOrderId}
      />
    );
  });

  return (
    <div className="w-full flex">
      <div className="w-1/3 min-h flex flex-col h-screen border-r">
        <div className="w-full text-lg font-semibold bg-secondary text-center p-2">
          Historique des commandes
        </div>
        <div className="mx-auto">
          <Pagination
            paginationInfo={{
              page,
              perPage,
              hasNext: data?.paginationInfo.hasNext || false,
              count: data?.paginationInfo.count || 1,
            }}
            setPage={setPage}
            setPerPage={setPerPage}
          />
        </div>
        {renderedPastOrders}
      </div>
      <div className="w-2/3">
        {selectedOrderId && <OrderDetails orderId={selectedOrderId} />}
      </div>
    </div>
  );
};

export default OrderHistory;
